// @ts-nocheck
import { useEffect, useState } from "react"
import { supabaseClient } from "@/lib/supabase/client"
import { TopicCard } from "@/components/topics/TopicCard"
import { useAuth } from "@/components/layout/AuthProvider"

export default function TopicsPage() {
  const { supabaseUser } = useAuth()
  const [topics, setTopics] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabaseClient.from("topics").select("*").order("post_count", { ascending: false }).limit(60)
      .then(({ data }) => { setTopics(data || []); setLoading(false) })
  }, [])

  return (
    <div className="container-app py-4">
      <div className="mb-6">
        <h1 className="font-bold text-xl">Topics</h1>
        <p className="text-text-muted text-sm mt-1">Discover communities</p>
      </div>
      {loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {Array.from({ length: 9 }).map((_, i) => <div key={i} className="skeleton-ig h-24 rounded-xl" />)}
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {topics.map(topic => <TopicCard key={topic.id} topic={topic} userId={supabaseUser?.id || null} />)}
        </div>
      )}
    </div>
  )
}